module.exports = __webpack_public_path__ + "static/img/banner@2x.675fe85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner@2x.png
// module id = 8ba9
// module chunks = 8